import { isAnyOf } from '@reduxjs/toolkit';
import { createGenericSlice } from '../genericSlice.js';
import { logout, login, register } from './thunks.js';
import initialState from './initialState.js';
import 'lodash/set';
import '../../types/index.js';
import '../../checkout-Ee1eEXQH.js';
import '../../menu-0TyOg98i.js';
import '../../product-_pRduMz7.js';
import '../../modal-6vnX5SO3.js';
import '../../services/auth/index.js';
import '../../utils/logToSlack.js';
import '../../utils/cookies.js';
import 'cookies-next';
import '../../cookies-l-jEMp6P.js';
import '../../currency-_kacFJHO.js';
import '../../language-BHHwgtQp.js';
import '../../payment-a4IKjS7g.js';
import '../../utils/isBot.js';
import '../../utils/currency.js';
import 'react';
import '../../context/index.js';
import 'lodash/get';
import 'next/router';
import '../../helpers-qU2Vf3ni.js';
import '../../utils/product.js';
import '../../utils/logger.js';
import '../../paths-ZKN3m62_.js';
import 'lodash';
import '../../GenerateCustomerToken-nBNO7Rhh.js';
import '../../GetCustomerInfo-QRC3rgNh.js';
import '../../requestsCollection-oNJgKLxK.js';
import 'graphql-request';
import 'lodash/cloneDeep';
import '../../utils/fetchPolicyLookup.js';
import '../../utils/error.js';
import '../../serverErrors-JVvpO9sB.js';
import '../../utils/logToRelic.js';
import '../../register-J9OaMUYD.js';
import '../../utils/cart.js';
import '../../MergeCarts-wo9UjKo5.js';
import '../../ProcessReactivateCart-fk5bSKoR.js';
import '../../utils/price.js';
import 'number-currency-format';
import '../../cart-2F1GQeXK.js';
import '../../utils/wishlist.js';
import '../wishlist/thunks.js';
import '../../RemoveProductsFromWishlist-WCaYiZlq.js';
import '../../wishlist-foOHzuD7.js';
import '../../utils/parseJSON.js';
import '../../localStorage-h6SlcHvK.js';
import '../wishlist/index.js';
import '../../utils/transformWishlistModel.js';
import '../wishlist/initialState.js';

const userSlice = createGenericSlice({
    name: 'user',
    initialState,
    reducers: {
        changeAuth: (state, action) => {
            const user = action.payload;
            state.current = user;
            state.authenticated = !!user;
            state.isFulfilled = true;
        },
        changeIsFulfilled: (state, action) => {
            state.isFulfilled = action.payload;
        },
    },
    extraReducers: builder => {
        // using spread syntax to avoid overwrite `requestStatuses` prop by initialState
        builder.addCase(logout.fulfilled, state => ({ ...state, ...initialState, isFulfilled: true }));
        builder.addMatcher(isAnyOf(login.fulfilled, register.fulfilled), (state, { payload }) => {
            state.current = payload;
            state.authenticated = true;
            state.isFulfilled = true;
        });
    },
});
const { changeAuth, changeIsFulfilled } = userSlice.actions;
var index = userSlice.reducer;

export { changeAuth, changeIsFulfilled, index as default };
//# sourceMappingURL=index.js.map
